import { DSAccordion, DSAccordionItem } from '@elliemae/ds-accordion';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { Grid } from '@elliemae/ds-grid';
import { Component } from 'react';
import { QueryBuilderContext } from '../QueryBuilderContext/QueryBuilderContext.js';

const { cssClassName } = convertPropToCssClassName('query-builder-output');

class DisplayOutput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  handleChange = () => {
    this.setState(({ show }) => ({
      show: !show,
    }));
  };

  render() {
    const { show } = this.state;
    const { showLabel, hideLabel, displayFixedOutput } = this.props;
    return (
      <QueryBuilderContext.Consumer>
        {({ format }) => {
          let display = '';
          try {
            display = typeof format === 'object' ? JSON.stringify(format) : format;
          } catch (e) {
            display = e;
          }
          if (displayFixedOutput) {
            return (
              <div className={cssClassName} data-testid="qb-fixed-output-wrapper">
                <Grid p="xxs">
                  <strong data-testid="qb-fixed-output-label">{displayFixedOutput}</strong>
                </Grid>
                <Grid pl="xxs" pr="xxs" data-testid="qb-fixed-output-content">
                  {display}
                </Grid>
              </div>
            );
          }

          return (
            <div className={cssClassName}>
              <DSAccordion activeValue={show} onChange={this.handleChange}>
                <DSAccordionItem title={show ? hideLabel : showLabel} value>
                  <div>{display}</div>
                </DSAccordionItem>
              </DSAccordion>
            </div>
          );
        }}
      </QueryBuilderContext.Consumer>
    );
  }
}

export default DisplayOutput;
